import React from 'react';
import PropTypes from 'prop-types';

export class ModalContainer extends React.PureComponent {

    static propTypes = {
        smallDialogMode: PropTypes.bool, // default false (1000px max width), if true 550px max width
        onClickClose: PropTypes.func,
        title: PropTypes.string.isRequired
    }

    render() {

        if (!this.props.children) return null;

        let modalClassName = "modal2";
        if (this.props.smallDialogMode) modalClassName += " small-format";

        let closeButton = null;
        if (this.props.onClickClose) {
            closeButton = (<button>
                    <i className="material-icons white" onClick={this.props.onClickClose}>clear</i>
                </button>)
        }

        return (
            <div className="modal2-container">
                <div className={modalClassName}>
                    <header>
                        <span>
                            {this.props.title}
                        </span>
                        {closeButton}
                    </header>
                    <section className="modal2-inner-content">
                        {this.props.children}
                    </section>
                </div>
            </div>
        )
    }
}

export class ConfirmationDialog extends React.PureComponent {

    constructor(props) {
        super(props);
    }
    static propTypes = {
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        cancelButtonAction: PropTypes.func.isRequired,
        cancelButtonTitle: PropTypes.string.isRequired,
        hideHeaderCloseButton: PropTypes.bool, // set to true when you want to force user to make a choice
        submitButtonAction: PropTypes.func.isRequired,
        submitButtonTitle: PropTypes.string.isRequired,
        rawHtml: PropTypes.bool
    }

    render () {
        return (
            <ModalContainer title={this.props.title} onClickClose={this.props.hideHeaderCloseButton ? null : this.props.cancelButtonAction} smallDialogMode={true} >
                <div className="message">
                    {this.props.rawHtml ? <span dangerouslySetInnerHTML={{__html: this.props.message}} /> : this.props.message}
                </div>
                <div className="actions">
                    <button className="destructive" onClick={this.props.cancelButtonAction} >
                        {this.props.cancelButtonTitle}
                    </button>
                    <button onClick={this.props.submitButtonAction} >
                        {this.props.submitButtonTitle}
                    </button>
                </div>
            </ModalContainer>
        )
    }
}